import { useEffect, useState, useRef } from "react";
import { db, storage } from "./firebase.js";
import BgShape from "../images/hero/bookbg.jpg";
import { addDoc, collection, query, where, getDocs } from "firebase/firestore";
import PhoneInput from "react-phone-number-input";
import "./numberinput.css";
import SignatureCanvas from "react-signature-canvas";
import {
  ref,
  uploadString,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import WaitModal from "./modal.jsx";


function Bookdrone({ isModalOpen, closeModal }) {

  const sigCanvas = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pickTime, setPickTime] = useState("");
  const [pickingTime, setPickingTime] = useState("");

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
  }, [isModalOpen]);

  const [checkboxState, setCheckboxState] = useState(false);

  const handleCheckboxChange = () => {
    setCheckboxState(!checkboxState);
  };

  const [price, setPrice] = useState(0);
  const [numATVs, setNumATVs] = useState("1");
  const [numKids12, setNumKids12] = useState("0");
  const [numKids4, setNumKids4] = useState("0");


  const handleTimeChange = (e) => {
    setPickingTime(e.target.value);
  };

  const handleNumATVsChange = (e) => {
    setNumATVs(e.target.value);
  };

  const handleNumKidsChange12 = (e) => {
    setNumKids12(e.target.value);
  };

  const handleNumKidsChange4 = (e) => {
    setNumKids4(e.target.value);
  };

  useEffect(() => {
    const newPrice = numATVs * 200
    setPrice(newPrice);
  }, [numATVs, numKids12, numKids4]);


  const [images, setImages] = useState([]); // State for selected images
  const [imageURLs, setImageURLs] = useState([]); // State for image URLs

  const uploadImages = async () => {
    const imageUploadPromises = images.map(async (image) => {
      const storageRef = ref(storage, `images/${image.name}`);
      await uploadBytes(storageRef, image);
      return await getDownloadURL(storageRef);
    });

    return await Promise.all(imageUploadPromises);
  };


  const [showModal, setShowModal] = useState(false);

  // Function to trigger the modal
  const handleShowModal = () => {
    setShowModal(true);
  };


  const PaymentAlert = () => {
    setTimeout(() => {
      window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;
    }, 7000); // 5-second delay
  };


  const convertTo12HourFormat = (timeString) => {
    const [hour, minute] = timeString.split(":");
    const parsedHour = parseInt(hour, 10);
    const ampm = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour % 12 === 0 ? 12 : parsedHour % 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };


  const postBooking = async () => {
   
    //window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;
    const currentDate = new Date();
     

    try {
      

      if (!name || !phone || !email) {
        alert("Error: Fill All Fields!");
        return;
      }

      if (!pickTime) {
        alert("Please choose date first.");
        return;
      }

      if (pickingTime <= "08:59" || pickingTime >= "17:01") {
        window.alert("Time available is from between 9AM To 5PM. Please select time accordingly. ");
        return;
      }

      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      const formattedTime = convertTo12HourFormat(pickingTime);

     // const imageDownloadURLs = await uploadImages();

      await addDoc(collection(db, "drone"), {
        picktime: pickTime,
        pickingtime: formattedTime,
        pkg: "Drone Photoshoot",
        name: name,
        seats: numATVs,
        phone: phone,
        email: email,
        date: formattedDate,
        price:price,
        date: formattedDate,
        disbtn:"no",


      });

     // window.location.href = `https://www.fygaro.com/en/pb/096b655f-779b-4c9b-8c04-f854187a834f/?amount=${price}`;

     // alert(
    //    "To complete booking, Please make the payment when this page is redirected. Press ok"
    //  );

       handleShowModal()
       PaymentAlert()

      closeModal();
      document.querySelector(".booking-done").style.display = "flex";
      setPickTime("");
      setName("");
      setPhone("");
      setEmail("");
      setPickingTime("");
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    postBooking();
  };

 

  return (
    <>
      <div
        className={`booking-modal ${isModalOpen ? "active-modal" : ""}`}
        style={{ zIndex: "24" }}
      >
        <div
          className="booking-modal__title"
          style={{
            backgroundColor: "#5078f2",
            backgroundImage: "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)", marginTop:'24px'
          }}
        >
          <h2>Complete Reservation</h2>
          <button
            onClick={closeModal}
            style={{
              height: "35px",
              width: "35px",
              backgroundColor: "red",
              color: "white",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            X
          </button>
        </div>
        <div className="booking-modal__message">
          <h4 style={{ color: "blue" }}>
            <i className="fa-solid fa-circle-info"></i> Upon completing this
           booking form:
          </h4>
          <p>
          You will redirected to payment page, a booking will only be confirmed if you make the payment. No action needed after making the payment. Kindly always call us before arrival.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            padding: "20px",
            height: "120vh", // Center content vertically
          }}
        >
          
          
           <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Number of People 
              <b style={{ color: "red" }}>*</b>
            </label>
            <select
              id="numATVs"
              value={numATVs}
              onChange={handleNumATVsChange}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px", // Wider dropdown
                marginTop: "10px",
              }}
            >
              {[...Array(20)].map((_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </select>
          </div>
          
          
         
         

          {/* 
          <div style={{ textAlign: "center" }}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i> Need A Guide?
              <b style={{ color: "red" }}>*</b>
            </label>
            <select
              id="numKids12to16"
              value={numKids12}
              onChange={handleNumKidsChange12}
              style={{
                padding: "10px",
                fontSize: "18px",
                width: "200px",
                marginTop: "10px",
              }}
            >
                 <option value={0}>Choose Option</option>
                    <option value={1}>Yes</option>
                    <option value={0}> No</option>
            </select>
          </div>
 */}
          <label htmlFor="picktime" style={styles.labelprice}>
              <i className="fa-regular fa-calendar-days"></i>Total Price: <b style={{ color: "green" }}>{price} USD</b> 
        </label>
        </div>

    

        <div style={styles.formContainer}>
          {/* Pick-up Date Picker */}
          <div style={styles.fieldContainer}>
            <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Choose Date
              <b style={{ color: "red" }}>*</b>
            </label>
            <input
              id="picktime"
              value={pickTime}
              onChange={(e) => setPickTime(e.target.value)}
              type="date"
              style={styles.dateInput}
            />
          </div>

          <label htmlFor="picktime" style={styles.label}>
              <i className="fa-regular fa-calendar-days"></i>Start Time
              <b style={{ color: "red" }}>*</b>
            </label>
            <p style={{padding:'10px'}}>Please Select Time In Range From 9AM To 5PM </p>
                  <input
                    id="droptime"
                    value={pickingTime}
                    onChange={handleTimeChange}
                    type="time"
                    className="input-time"
                    style={{ width: "150px" }}
                  />
        </div>

        <div className="booking-modal__person-info">
          <h4 style={{ color: "blue" }}>Personal Information</h4>
          <form className="info-form">
            <div className="info-form__2col">
              <span>
                <label>
                  Full Name <b>*</b>
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Enter full name"
                ></input>
              </span>
              <span>
                <div className="phoneInputContainer">
                  <label className="label">
                    Phone Number <b>*</b>
                  </label>
                  <div className="phoneInputWrapper">
                    <PhoneInput
                      international
                      defaultCountry="US"
                      value={phone}
                      onChange={setPhone}
                      placeholder="Enter your phone number"
                      className="phoneInput"
                    />
                  </div>
                </div>
              </span>
            </div>
            <div className="info-form__1col">
              <span>
                <label>
                  Email <b>*</b>
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Enter your email address"
                ></input>
              </span>
            </div>

            <div className="info-form__1col">
              <span>
                <h4>Terms & Conditions</h4>

                <p style={{fontWeight:'bold', fontSize:'13px'}}>
                 Our Policy: We have 48 hours no cancellations policy! No refund for no show at the above location And time you booked for, no change date or time!
                </p>
              </span>
            </div>

          

           


            <div className="reserve-button">
              <button
                onClick={confirmBooking}
                style={{
                  backgroundColor: "#182b3a",
                  backgroundImage:
                    "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)",
                }}
              >
                Reserve Now
              </button>
           
            </div>
           
          </form>
        </div>
       
      </div>
      <WaitModal show={showModal} setShow={setShowModal} />
    </>
  );
}

const styles = {
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "40vh",
    backgroundColor: "#f7f9fc",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
  },
  fieldContainer: {
    marginBottom: "20px",
    textAlign: "center",
  },
  label: {
    color: "blue",
    fontSize: "2rem",
    display: "block",
    marginBottom: "8px",
    textAlign: "center",
  },
  labelprice: {
    color: "green",
    fontSize: "2.2rem",
    display: "block",
    marginBottom: "30px",
    textAlign: "center",
  },

  dateInput: {
    padding: "8px 12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "1.7rem",
    textAlign: "center",
  },
  timeSlotContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
  },
  timeSlotButton: {
    padding: "12px 20px",
    // fontSize: "1rem",
    backgroundColor: "#d9d9d9",
    color: "#333",
    border: "2px solid #ccc",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    width: "210px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  selectedButton: {
    backgroundColor: "#4caf50",
    color: "white",
    borderColor: "#4caf50",
  },
};

export default Bookdrone;
